import type { ReactNode } from "react";
import Skeleton from "react-loading-skeleton";
import { Box } from "@material-ui/core";

import "../styles.scss";

export interface IHotelNameProps {
  isSkeleton?: boolean;
  name: ReactNode;
}

const HotelName = ({
  isSkeleton = false,
  name,
}: IHotelNameProps): JSX.Element => {
  return (
    <Box className="hotel-name">
      {isSkeleton ? (
        <Skeleton className="hotel-availability-info-skeleton name" />
      ) : (
        name
      )}
    </Box>
  );
};

export default HotelName;
